export type TipoProduto = 'MOTOR_CONCILIACAO' | 'MAPA_RESULTADOS' | 'REVISOR_CONTABIL' | 'WORKFLOW_SOX';

interface ProdutoIntegradoBase {
  empresaId: number;
  cicloId: number;
}

/** Dado real de GET /api/Dashboard/ConciliacaoContabilFinanceira/{empresaId}/resumo — sem drill-down de contas divergentes nem contagem de lançamentos (não existe nesse nível de agregação). */
export interface MotorConciliacaoDados extends ProdutoIntegradoBase {
  tipo: 'MOTOR_CONCILIACAO';
  percentualProcessado: number;
  contasTotais: number;
  contasConcluidas: number;
  contasPendentes: number;
  contasComDivergencia: number;
  diferencaAConciliar: number;
}

/** Dado real de GET /api/Esteira/{esteiraId}/resumo-resultado — progresso de conciliação das contas de resultado (3./4.), não um cálculo de DRE (esse motor não existe no backend). */
export interface MapaResultadosDados extends ProdutoIntegradoBase {
  tipo: 'MAPA_RESULTADOS';
  contasTotais: number;
  contasConcluidas: number;
  contasPendentes: number;
  contasComDivergencia: number;
  percentualConcluido: number;
}

/** Dado real de GET /api/auditoria/resumo-consolidado — soma erros/alertas/avisos de todos os módulos de auditoria (Revisor Contábil), exceto Tributos legado. */
export interface RevisorContabilDados extends ProdutoIntegradoBase {
  tipo: 'REVISOR_CONTABIL';
  modulosAvaliados: number;
  modulosComFalha: number;
  erros: number;
  alertas: number;
  avisos: number;
  impactoTotalEstimado: number;
}

/** Dado real de GET /api/workflow/monitoramento — itens ativos na fila de aprovação SOX (não há "concluídos"/"evidências pendentes" nesse endpoint). */
export interface WorkflowSoxDados extends ProdutoIntegradoBase {
  tipo: 'WORKFLOW_SOX';
  itensNaFila: number;
  emAlerta: number;
  foraDoPrazo: number;
}

export type ProdutoIntegrado = MotorConciliacaoDados | MapaResultadosDados | RevisorContabilDados | WorkflowSoxDados;

export const isMotorConciliacao = (p: ProdutoIntegrado): p is MotorConciliacaoDados => p.tipo === 'MOTOR_CONCILIACAO';
export const isMapaResultados = (p: ProdutoIntegrado): p is MapaResultadosDados => p.tipo === 'MAPA_RESULTADOS';
export const isRevisorContabil = (p: ProdutoIntegrado): p is RevisorContabilDados => p.tipo === 'REVISOR_CONTABIL';
export const isWorkflowSox = (p: ProdutoIntegrado): p is WorkflowSoxDados => p.tipo === 'WORKFLOW_SOX';
